import React from 'react';

function nftmarket() {
	return (
		<div class="col-md-10 nftmarket">
			<div class="greeting">
				<img src={`${process.env.PUBLIC_URL}/images/panel2.png`} />
				<img src={`${process.env.PUBLIC_URL}/images/gdmobile.png`} />
			</div>
			<div class="row">
			    <h3>Latest Auction</h3>
			 <div class="row">
				<div class="col-md-3">
					<div class="inner">
						<img src={`${process.env.PUBLIC_URL}/images/auction1.png`} /> 
						<p class="title">Brontosaurus (#4339789)</p>
						<p class="price">Starting Price
							<span class="floatRight"><img src={`${process.env.PUBLIC_URL}/images/singlecoin.png`} /> 120.00</span>
						</p>
						<p class="status">status<span class="floatRight">Auctioned</span></p>
					</div>
				</div>
				<div class="col-md-3">
					<div class="inner">
						<img src={`${process.env.PUBLIC_URL}/images/auction2.png`} /> 
						<p class="title">Brontosaurus (#4339789)</p>
						<p class="price">Starting Price
							<span class="floatRight"><img src={`${process.env.PUBLIC_URL}/images/singlecoin.png`} /> 120.00</span>
						</p>
						<p class="status">status<span class="floatRight">Auctioned</span></p>
					</div>
				</div>
				<div class="col-md-3">
					<div class="inner">
						<img src={`${process.env.PUBLIC_URL}/images/auction3.png`} /> 
						<p class="title">Brontosaurus (#4339789)</p>
						<p class="price">Starting Price
							<span class="floatRight"><img src={`${process.env.PUBLIC_URL}/images/singlecoin.png`} /> 120.00</span>
						</p>
						<p class="status">status<span class="floatRight">Auctioned</span></p>
					</div>
				</div>
				<div class="col-md-3">
					<div class="inner">
						<img src={`${process.env.PUBLIC_URL}/images/auction4.png`} /> 
						<p class="title">Brontosaurus (#4339789)</p>
						<p class="price">Starting Price
							<span class="floatRight"><img src={`${process.env.PUBLIC_URL}/images/singlecoin.png`} /> 120.00</span>
						</p>
						<p class="status">status<span class="floatRight">Auctioned</span></p>
					</div>
				</div>
			 </div>
			</div>
			<div class="row">
				<h3>Latest Release</h3>
			 <div class="row">
				<div class="col-md-3">
					<div class="inner">
						<img src={`${process.env.PUBLIC_URL}/images/release1.png`} /> 
						<p class="title">Brontosaurus (#4339789)</p>
						<p class="price">Starting Price
							<span class="floatRight"><img src={`${process.env.PUBLIC_URL}/images/singlecoin.png`} /> 120.00</span>
						</p>
					</div>
				</div>
				<div class="col-md-3">
					<div class="inner">
						<img src={`${process.env.PUBLIC_URL}/images/release2.png`} /> 
						<p class="title">Brontosaurus (#4339789)</p>
						<p class="price">Starting Price
							<span class="floatRight"><img src={`${process.env.PUBLIC_URL}/images/singlecoin.png`} /> 120.00</span>
						</p>
					</div>
				</div>
				<div class="col-md-3">
					<div class="inner">
						<img src={`${process.env.PUBLIC_URL}/images/release3.png`} /> 
						<p class="title">Brontosaurus (#4339789)</p>
						<p class="price">Starting Price
							<span class="floatRight"><img src={`${process.env.PUBLIC_URL}/images/singlecoin.png`} /> 120.00</span>
						</p>
					</div>
				</div>
				<div class="col-md-3">
					<div class="inner">
						<img src={`${process.env.PUBLIC_URL}/images/release4.png`} /> 
						<p class="title">Brontosaurus (#4339789)</p>
						<p class="price">Starting Price
							<span class="floatRight"><img src={`${process.env.PUBLIC_URL}/images/singlecoin.png`} /> 120.00</span>
						</p>
					</div>
				</div>
			 </div>
			</div>
		</div>
	);
}

export default nftmarket;
			